export const tagManagerBlacklistPaths = ["/reset-password"];
